// Each line completes "Drink if you think...".
// "The other player" always means the person paired with you on this card.
export const regularPacks = {
  'new friends': [
    "the other player has a surprisingly strong opinion about airport etiquette.",
    "you could convince this room that a completely fake holiday is real.",
    "the other player gives their houseplants names.",
    "between you, you would be the one reading the museum plaques.",
    "a stranger has mistaken you for someone much more interesting.",
    "the other player would choose the mystery box over a guaranteed prize.",
    "you would trust the other player to order lunch for you.",
    "the other player has a spreadsheet for something that does not need one.",
    "your most-used emoji would give the wrong first impression.",
    "you two would become friends if you got stuck in a broken elevator.",
    "the other player secretly loves being asked for directions.",
    "you could live without music longer than the other player could.",
    "the other player has an unexpectedly good villain laugh.",
    "your search history contains a question you should already know the answer to.",
    "the other player would bring a costume to a party with no dress code.",
    "you would be the one to accidentally join a stranger's family photo.",
    "silence between new friends does not need fixing.",
    "the other player could sell you something you absolutely do not need.",
    "you are easier to befriend in a kitchen than on a dance floor.",
    "the other player would correct a small error on a restaurant bill in your favor.",
    "you two would disagree about what counts as being on time.",
    "your hobby sounds fake when you explain it out loud.",
    "the other player has practiced an acceptance speech.",
    "you would trust the other player to pick your next audiobook.",
    "you are more likely to leave a party without saying goodbye.",
    "the other player looks calm but has twelve mental tabs open.",
    "you would rather be interesting to one person than popular in the room.",
    "the other player would remember your pet's name before yours.",
    "you could identify the other player's order at a bakery.",
    "you have a harmless opinion you save until people know you better.",
    "the other player would enjoy a holiday with no itinerary at all.",
    "you two could successfully run a market stall together.",
    "the other player has a voice they only use with customer service.",
    "you would be the first of you to admit you did not understand the joke.",
    "your first impression of the other player has already changed."
  ],
  'old friends': [
    "the other player has retold one of your stories as if they were there.",
    "you know which emoji from the other player means actual trouble.",
    "the other player would recognize your fake polite laugh immediately.",
    "you are still owed an apology for a board-game incident.",
    "the other player has a secret favorite person in the group chat.",
    "you could pick the other player's worst-ever haircut out of a lineup.",
    "your friendship has survived a trip that should have been a warning.",
    "the other player would defend you publicly and roast you privately.",
    "you were the bad influence in at least one of your shared stories.",
    "the other player has conveniently edited their role in your origin story.",
    "you could tell when the other player wrote a text with AI.",
    "the other player would answer your call at 3 a.m. and complain the whole time.",
    "you are more sentimental about this friendship than you let on.",
    "the other player is overdue for a completely unnecessary rebrand.",
    "you two could settle an old argument using a single screenshot.",
    "the other player would spend your lottery winnings before you collected them.",
    "you have pretended to remember someone the other player introduced you to.",
    "the other player has a signature exit line that fools nobody.",
    "you could pack an emergency overnight bag for the other player.",
    "the other player enjoys the planning drama more than the actual event.",
    "you have kept an objectively terrible gift because this friend gave it to you.",
    "the other player could identify you from your walk at a distance.",
    "you are responsible for at least one phrase the whole group now uses.",
    "the other player would turn your minor inconvenience into a six-part investigation.",
    "you two would have hated each other if you met five years earlier.",
    "the other player is kinder than their group-chat persona suggests.",
    "you have an embarrassing photo of this friend you would never actually post.",
    "the other player would notice a fake story in your memoir.",
    "your friends know your food order better than your job title.",
    "the other player has a sworn enemy who has no idea they are enemies.",
    "you could name the other player's abandoned hobby collection.",
    "the other player would make a reunion feel like no time had passed.",
    "you two disagree about who started your funniest inside joke.",
    "you owe the other player for talking you out of a terrible purchase.",
    "the other player has been right about someone you refused to listen about."
  ],
  family: [
    "the other player hides the good snacks from everyone else.",
    "you can name a family tradition nobody remembers starting.",
    "the other player would rescue the photo albums before the television.",
    "you are the family member most likely to read the instructions aloud.",
    "the other player has a favorite mug nobody else is allowed to use.",
    "you two would build a better snowman together than separately.",
    "the other player remembers your childhood nickname a little too fondly.",
    "you have inherited a family habit you used to make fun of.",
    "the other player would insist the scenic route is only five minutes longer.",
    "you could guess which family recipe the other player would save.",
    "the other player is secretly pleased when someone asks for seconds.",
    "you are more attached to holiday traditions than you admit.",
    "the other player has a drawer of cables for devices you no longer own.",
    "you two would pick the same person to narrate a family documentary.",
    "the other player would frame a slightly blurry photo because everyone looks happy.",
    "you know which family story has grown the most with every retelling.",
    "the other player says they do not want a fuss and still expects a cake.",
    "you could recognize a relative just by the sound of their keys.",
    "the other player would feed a visiting repair person a full meal.",
    "you would rather receive an old family photo than a new gadget.",
    "the other player has already decided who gets their best recipe.",
    "you have become the person who tells everyone to bring a jacket.",
    "the other player would keep a child's drawing on the fridge for a decade.",
    "you two would disagree about the correct thermostat setting.",
    "the other player could tell who left a cup somewhere by what is in it.",
    "you can name a tiny kindness from your family that you still remember.",
    "the other player would start a friendly competition over wrapping presents.",
    "you are better at keeping plants alive than family secrets.",
    "the other player thinks their seat at the table is legally reserved.",
    "you would choose a chaotic family picnic over a perfectly organized dinner."
  ],
  'hot takes': [
    "a cancelled plan can be a better gift than a surprise plan.",
    "the other player would defend a terrible film just because they saw it young.",
    "reclining on a short flight is an act of war.",
    "you are allowed to leave a party after forty-five excellent minutes.",
    "the other player judges restaurants by their bathrooms.",
    "a voice note over two minutes should come with chapter markers.",
    "being good at trivia is mostly remembering things nobody asked you to.",
    "the other player thinks they could improve your playlist.",
    "a wedding needs fewer speeches and more comfortable chairs.",
    "people who say they have no guilty pleasures are hiding the best ones.",
    "the other player would read the ending of a book first.",
    "breakfast food deserves access to every meal slot.",
    "a tiny spoon makes dessert better.",
    "the other player would rather be overdressed than underdressed.",
    "every friend group needs one person who actually makes the reservation.",
    "an unflattering candid photo can be the best photo of the night.",
    "the other player would lose respect for your favorite pizza topping.",
    "a short queue is not a good enough reason to join a queue.",
    "adults deserve occasional gold-star stickers.",
    "the other player would pay extra to avoid a phone call.",
    "knowing when to leave is more impressive than knowing how to arrive.",
    "a shared hatred of one song can launch a friendship.",
    "the other player believes their packing method is the correct one.",
    "a holiday with no stories of things going wrong is suspicious.",
    "people should have to earn the right to control the car temperature.",
    "the other player would rather win an argument than find the restaurant.",
    "being a good guest is an underrated life skill.",
    "a nap is a legitimate weekend plan.",
    "the other player secretly likes a trend they publicly complain about.",
    "the best part of a fancy event is the snack you get afterward."
  ],
  'new couples': [
    "the other player rehearsed their first message to you.",
    "you are still presenting the tidier version of yourself.",
    "the other player asked a friend to decode one of your texts.",
    "you could pick a date the other player would enjoy without spending money.",
    "your friends already know more about this person than you have admitted.",
    "the other player has a surprisingly different idea of a relaxing Sunday.",
    "you noticed their laugh before you noticed their outfit.",
    "the other player would rather hear a clumsy compliment than a polished line.",
    "you would be the first to suggest deleting the dating apps.",
    "the other player is curious about a story you have only hinted at.",
    "your first-date nerves made you talk faster than usual.",
    "the other player would prefer a planned date to a spontaneous one.",
    "you two would handle a missed train well together.",
    "the other player has already noticed one of your nervous habits.",
    "you are more comfortable making the first plan than naming your feelings.",
    "the other player would enjoy meeting your weirdest friend.",
    "you have changed an outfit because you wondered what they would think.",
    "the other player remembers a tiny detail you forgot you mentioned.",
    "your ideal amount of texting is different from theirs.",
    "the other player wants to ask you something but is waiting for the moment.",
    "you would rather discover a disagreement early than agree on everything.",
    "the other player could surprise you with their music taste.",
    "you have deliberately saved a good story for your next date.",
    "the other player likes your enthusiasm more than your cool act.",
    "you two would choose different sides of the bed.",
    "the other player would like the version of you your oldest friends know.",
    "you have mistaken thoughtfulness for flirting before.",
    "the other player would rather cook together than be cooked for.",
    "you are quicker to introduce someone to friends than to family.",
    "the other player would tell you if you had something in your teeth.",
    "you have a dealbreaker that would sound silly until you explained it.",
    "the other player is more romantic in private than in public.",
    "you two could enjoy doing separate things in the same room.",
    "the other player has already imagined a second trip after your first.",
    "you feel more like yourself with them than you expected to this soon."
  ],
  'old couples': [
    "the other player can identify your mood from how you close a cupboard.",
    "you have accepted that their version of loading the dishwasher will never change.",
    "the other player knows your fake 'I'm fine' voice.",
    "you two have an argument that is now basically a family tradition.",
    "the other player would pick your perfect low-energy birthday.",
    "you still try to impress them with one particular skill.",
    "the other player has adopted a phrase they used to tease you for.",
    "you remember the first ordinary moment that felt like a life together.",
    "the other player knows exactly when to offer food instead of advice.",
    "you have become more alike in a way your friends find funny.",
    "the other player would recognize a shopping list written by you.",
    "you owe them credit for something you now claim was your idea.",
    "the other player still surprises you with how their mind works.",
    "you could recreate an early date from memory.",
    "the other player has a household task they think counts as three tasks.",
    "you know the difference between their listening face and their thinking-about-dinner face.",
    "the other player would keep your oldest shared furniture for sentimental reasons.",
    "you have learned to translate their extremely specific sighs.",
    "the other player wants a new shared tradition more than another anniversary gift.",
    "you two have different definitions of 'ready to leave'.",
    "the other player has improved your taste in at least one thing.",
    "you have secretly kept a note or ticket from the beginning.",
    "the other player can predict which relative will annoy you at dinner.",
    "you are better at making up now than you were at the start.",
    "the other player would choose a familiar favorite over a surprise anniversary plan.",
    "you miss an activity you used to do together and could bring back.",
    "the other player has a version of your shared story you like better than yours.",
    "you two could communicate a complete opinion with one look across a room.",
    "the other player notices more of your small efforts than they say.",
    "you would choose each other as teammates even without the romantic part.",
    "the other player has changed their mind on something because of you.",
    "you are now the couple whose habits you once made fun of.",
    "the other player would enjoy hearing a compliment you assume they already know.",
    "you have forgotten an old disagreement but remember the kind thing afterward.",
    "the other player knows a dream of yours that deserves another attempt."
  ]
};

export const reclassifiedPacks = {
  'new friends': [
    "the other player has a dating-app screenshot that belongs in a museum.",
    "you have posted a thirst trap for an audience of exactly one.",
    "the other player would flirt their way out of paying a cover charge.",
    "you have had a crush on someone whose name you got wrong.",
    "the other player has a completely different personality in their DMs.",
    "you have left a party with someone and returned for your charger.",
    "the other player is a better kisser than texter.",
    "your flirting could be mistaken for a customer-satisfaction survey.",
    "the other player has a 'never again' ex who got another chance.",
    "you have checked whether a hot stranger was wearing a wedding ring.",
    "the other player would rather make the first move than wait all night.",
    "you have pretended not to see a hookup in public.",
    "the other player has an innocent-looking emoji with a very adult meaning.",
    "you could flirt convincingly with someone who is not your type.",
    "the other player has been on a date that felt like a job interview for sex.",
    "you have had a crush on someone's voice before seeing their face.",
    "the other player has a dating profile their friends would not recognize.",
    "you have used 'come over and watch something' with no interest in the film.",
    "the other player would be more embarrassed by their saved photos than their selfies.",
    "you have kept talking to someone because the chemistry was ridiculous.",
    "the other player has a crush that would require a ten-minute defense.",
    "you have reread a flirty message so often you could recite it.",
    "the other player knows exactly which photo of themselves causes trouble.",
    "you have kissed someone and immediately understood the hype.",
    "the other player has sent a risky text and thrown their phone across the bed.",
    "you have swiped right mainly to find out whether they would.",
    "the other player is more dangerous with eye contact than pickup lines.",
    "you have gone on a date with someone your friends nicknamed before meeting.",
    "the other player has said 'I'm not looking for anything' while looking very hard.",
    "you have been attracted to someone you could not stand in a meeting.",
    "the other player would tell a date directly that the chemistry was missing.",
    "you have made a perfectly innocent outfit decision for deeply unserious reasons.",
    "the other player could accidentally turn a compliment into a proposition.",
    "you have had a first kiss that deserved a second take.",
    "the other player has an ex saved under a warning instead of a name.",
    "you have flirted badly on purpose to make someone else make the move.",
    "the other player would recognize a booty call disguised as a weather update.",
    "you have been someone's 'we shouldn't' at least once.",
    "the other player would ask for a number while everyone else was still debating it.",
    "you have blamed bad Wi-Fi for a message you deliberately ignored.",
    "the other player has a scandalous story with an extremely boring opening.",
    "you would rather confess your worst date than explain your last late-night DM."
  ],
  'old friends': [
    "the other player has a roster of exes your group could identify by nickname.",
    "you have been the alibi for a date your friend did not want to explain.",
    "the other player has ignored the group's unanimous 'do not text them'.",
    "you know which friend gets suspiciously quiet when their crush arrives.",
    "the other player has flirted with someone they spent the whole evening criticizing.",
    "you have helped draft a sext that was not yours.",
    "the other player has claimed a hookup was 'just a friend' with no credibility.",
    "you could spot the other player's walk of shame from a silhouette.",
    "the other player has deleted a dating app with great ceremony and reinstalled it quietly.",
    "you have heard enough about a friend's sex life to deserve producer credit.",
    "the other player has a type and it is not 'emotionally available'.",
    "you know which friend should never be left alone with their ex at a wedding.",
    "the other player has sent a thirst trap to the group for quality control.",
    "you have given excellent dating advice and then done the exact opposite.",
    "the other player has a hookup story with a very inconvenient witness.",
    "you have recognized a friend's new date from someone else's dating disaster.",
    "the other player has called a situationship 'complicated' when it was just bad.",
    "you could name the crush the other player thinks they kept secret.",
    "the other player has made the group wait while choosing a 'casual' date outfit.",
    "you have watched a friend flirt and wanted to issue an apology on their behalf.",
    "the other player has an ex who should come with patch notes.",
    "you have received a 'don't judge me' text and immediately known who it concerned.",
    "the other player would be the first friend to admit they own a sex toy.",
    "you have heard a dating update that needed a family tree to follow.",
    "the other player has mistaken sexual chemistry for personal growth.",
    "you know a friend whose standards collapse around one specific accent.",
    "the other player has described a terrible date as 'good content'.",
    "you have concealed your real opinion of a friend's rebound for at least a week.",
    "the other player has a saved selfie they deploy after every breakup.",
    "you could predict which friend's ex will resurface during the holidays.",
    "the other player has gone home with someone after announcing they were having a quiet night.",
    "you have seen a friend flirt harder for a free upgrade than for love.",
    "the other player has a dating story the group is forbidden to tell at their wedding.",
    "you have helped someone escape a date using an obviously fake emergency.",
    "the other player has a 'platonic' friendship the group is not convinced about.",
    "you know who in this group would accidentally sext the wrong chat.",
    "the other player would choose great sex over their friends' approval.",
    "you have kept a friend's embarrassing romantic confession completely secret.",
    "the other player has a dating comeback story nobody requested.",
    "you have watched this friend dress for revenge and pretend it was laundry day.",
    "the other player has more chemistry with their rival than with their last date.",
    "you could give a guided tour of this friend's red flags and redeeming qualities."
  ],
  'new couples': [
    "the other player thought about kissing you before your first date ended.",
    "you have deliberately sat closer when there was plenty of space.",
    "the other player picked tonight's outfit with your reaction in mind.",
    "you are better at flirting in person than over text.",
    "the other player has imagined what waking up next to you would be like.",
    "you have stretched a goodbye because you wanted another kiss.",
    "the other player would rather hear what you want than be expected to guess.",
    "you have overanalyzed a message that was definitely flirting.",
    "the other player has an unexpectedly dirty sense of humor.",
    "you would admit a lack of experience instead of pretending to be an expert.",
    "the other player notices when you look at their lips.",
    "you have had great sex with someone you would never actually date.",
    "the other player is more confident making a move than accepting a compliment.",
    "you could talk about sex more easily on a walk than face to face at dinner.",
    "the other player would find a direct 'can I kiss you?' attractive.",
    "you have replayed your first kiss with them in your head.",
    "the other player has been trying to work out what your flirting means.",
    "you would rather discuss sexual boundaries early than rely on assumptions.",
    "the other player looks innocent and knows exactly what they are doing.",
    "you have held back a flirty text because it felt too soon.",
    "the other player would rather have awkward honesty than impressive pretending in bed.",
    "you would enjoy a date that ended with making out and nothing more.",
    "the other player is curious about your most ridiculous turn-off.",
    "the other player has told their friends whether you're a good kisser.",
    "the other player would be amused if your first overnight involved terrible snoring.",
    "you find confidence hotter when it includes asking what the other person likes.",
    "the other player can tell when you are trying to look unbothered.",
    "you would bring up STI testing before sleeping together.",
    "the other player has an ex they would not trust themselves to kiss goodbye.",
    "you have been caught checking out the other player and denied it badly.",
    "the other player would be comfortable saying 'not tonight' without inventing an excuse.",
    "you are more nervous about the first morning after than the first kiss.",
    "the other player could distract you with one well-timed compliment.",
    "you would rather laugh through an awkward intimate moment than act like it did not happen.",
    "the other player has a different definition of taking things slowly.",
    "you have found a very ordinary thing they do unexpectedly sexy.",
    "the other player would like you to be more obvious when you are flirting.",
    "you would be uncomfortable learning you were still one of several active hookups.",
    "the other player would take a playful tease as an invitation to tease you back.",
    "you have dressed for the possibility that a date might become an overnight stay.",
    "the other player would admit an unusual turn-on without apologizing for it.",
    "you would rather discuss kinks beforehand than discover a mismatch mid-hookup."
  ],
  'old couples': [
    "the other player can tell the difference between your cuddle invitation and your other invitation.",
    "you have sent a suggestive text from another room in the same home.",
    "the other player knows which outfit still gets your attention instantly.",
    "you have scheduled sex and found that the anticipation helped.",
    "the other player has a flirty look they only use with you.",
    "you two have abandoned an ambitious romantic plan because the bed was too comfortable.",
    "the other player would enjoy being asked on a date as if you had just met.",
    "you have delayed getting dressed because the other player was enjoying the view.",
    "the other player would choose a hotel night over an expensive anniversary present.",
    "you have used a ridiculous euphemism for sex in front of company.",
    "the other player knows when you are dressing for them instead of the occasion.",
    "you two have been interrupted at exactly the wrong moment by a pet.",
    "the other player would appreciate you making the first move more often.",
    "you have flirted during a conversation about an extremely unsexy household problem.",
    "the other player would rather hear an honest desire than repeat a familiar routine.",
    "you have sent them a sext so out of character they asked who stole your phone.",
    "the other player can make you blush with a reference nobody else understands.",
    "you two have a private code for leaving a party early together.",
    "the other player would rather admit a secret kink than share their entire search history.",
    "you have worn something uncomfortable because you knew exactly what they would think.",
    "the other player has become sexier to you by being dependable.",
    "you have learned that being rested can be more romantic than being spontaneous.",
    "the other player would be open to browsing a sex shop together, with no pressure to buy.",
    "you two have laughed during sex at something objectively not sexy.",
    "the other player knows a compliment that works on you every single time.",
    "you would rather talk about a change in desire than quietly take it personally.",
    "the other player would enjoy a make-out session with no assumption about what comes next.",
    "you have competed with a very comfortable pair of pajamas and lost.",
    "the other player knows which ex you would least like them to compare notes with.",
    "you two could be better at saying what you want without making it a hint.",
    "the other player has a dirty thought they have never quite said out loud to you.",
    "you have deliberately pretended not to notice them showing off for you.",
    "the other player would recognize the difference between your real and exaggerated bedroom enthusiasm.",
    "you have flirted harder with them on holiday than at home.",
    "the other player would say your chemistry has changed rather than disappeared.",
    "you two have a story that must never make it into an anniversary speech.",
    "the other player would enjoy pretending to be strangers flirting at a hotel bar.",
    "you would be willing to admit a bedroom routine has become a little too routine.",
    "the other player has a secret weapon that is mostly just rolling up their sleeves.",
    "you have negotiated who gets up afterward like it was an international treaty.",
    "the other player still likes hearing that you want them, even when it seems obvious.",
    "you two have earned the right to have a very unglamorous but excellent sex life."
  ],
  'hot takes': [
    "a great kisser with terrible conversation is still a terrible second date.",
    "the other player would forgive bad fashion before bad sexting.",
    "sex on a first date tells you nothing about someone's relationship potential.",
    "a thirst trap is an art form when the caption commits to the lie.",
    "the other player would choose chemistry over a perfect dating checklist.",
    "an ex watching every story is doing unpaid emotional surveillance.",
    "asking for consent can be smoother than any pickup line.",
    "the other player thinks a voice can rescue a mediocre dating profile.",
    "a hookup does not need a sequel to count as a good decision.",
    "matching energy is more attractive than playing hard to get.",
    "the other player would judge a date more for rude tipping than a high body count.",
    "dirty talk is mostly confidence and knowing when to stop talking.",
    "a late-night 'you up?' deserves a business-hours reply.",
    "the other player thinks being able to apologize is a turn-on.",
    "a situationship longer than a year needs an exit interview.",
    "separate blankets can improve a sex life more than expensive lingerie.",
    "the other player would rather date a great flirt than a perfect texter.",
    "a bad kiss can be improved but entitlement cannot.",
    "sexting while buying toilet paper is an underrated modern contradiction.",
    "the other player thinks cooking someone breakfast can be more intimate than sleeping with them.",
    "calling every ex crazy is a self-written warning label.",
    "owning a sex toy is less embarrassing than pretending you have never been curious.",
    "the other player would agree that an adult crush can ruin your vocabulary.",
    "a clear 'not interested' is kinder than a month of polite flirting.",
    "friends with benefits needs better communication than most relationships.",
    "the other player thinks a uniform gets far too much credit.",
    "being good in bed includes being able to hear feedback.",
    "a dating profile saying 'no drama' usually has a dramatic backstory.",
    "the other player would choose an awkward honest compliment over a flawless pickup line.",
    "a celebrity crush is not a realistic guide to choosing a partner.",
    "the morning-after conversation is the real compatibility test.",
    "the other player thinks a little sexual tension improves a boring dinner party.",
    "an accidental double-entendre is better than a rehearsed dirty joke.",
    "talking about safer sex should not be treated as killing the mood.",
    "the other player would rather be desired openly than pursued mysteriously.",
    "a person's number of past partners is not a personality assessment.",
    "flirting with your own partner is an underused relationship skill.",
    "the other player thinks a genuinely good listener can become dangerously attractive.",
    "an adult sleepover should come with access to a phone charger.",
    "mutually agreed casual sex can be less messy than undefined romance.",
    "the other player thinks mystery becomes annoying after the third date.",
    "good sexual chemistry is not evidence that you should sign a lease together."
  ]
};

const cardsFrom = (packs, explicit) => Object.entries(packs).flatMap(([type, prompts]) =>
  prompts.map((prompt, index) => ({
    id: `expansion2-${explicit ? 'spicy' : 'regular'}-${type.replace(/ /g, '-')}-${index + 1}`,
    description: `Drink if you think ${prompt}`,
    type,
    explicit,
    fresh: true
  }))
);
export const regularExpansion = cardsFrom(regularPacks, false);
// Preserve IDs and descriptions so saved favorites and played history still match.
export const reclassifiedExpansion = cardsFrom(reclassifiedPacks, true).map(card => ({ ...card, explicit: false }));
const expansion2 = [...regularExpansion, ...reclassifiedExpansion];
export default expansion2;
